module.exports = "https://deal.freetls.fastly.net/consumer/common/media/step-4.bec31ff4.mp4";